'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { toast } from '@algoacademy/design-system/web/feedback/Toaster/Toaster';
import { showErrorToast } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
type IssuedOfferLinkProps = {
  offerUrl: string;
  variant: 'sent' | 'emailFailed' | 'existing';
};
const COPY_BY_VARIANT: Record<IssuedOfferLinkProps['variant'], {
  title: string;
  description: string;
}> = {
  sent: {
    title: 'Link do oferty wysłany',
    description: 'E-mail z tym linkiem został wysłany kupującemu.'
  },
  emailFailed: {
    title: 'Link do oferty',
    description: 'E-mail nie został wysłany. Skopiuj link i przekaż go kupującemu ręcznie.'
  },
  existing: {
    title: 'Istniejący link do oferty',
    description: 'Ten link został wystawiony wcześniej i nadal prowadzi do płatności.'
  }
};

/**
 * The only place an issued link is ever shown - nothing lists offers - so the
 * address is printed in full, stays put after the toast fades, and is plain
 * selectable text rather than a link: opening it would start a Stripe payment.
 */
export function IssuedOfferLink(t0) {
  const $ = _c(16);
  const {
    offerUrl,
    variant
  } = t0;
  const copy = COPY_BY_VARIANT[variant];
  let t1;
  if ($[0] !== copy.title) {
    t1 = <p className="font-medium text-contentGreen text-sm">{copy.title}</p>;
    $[0] = copy.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== offerUrl) {
    t2 = <p className="w-full break-all font-mono text-contentPrimary text-sm">{offerUrl}</p>;
    $[2] = offerUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== copy.description) {
    t3 = <p className="text-contentSecondary text-sm">{copy.description}</p>;
    $[4] = copy.description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== offerUrl) {
    t4 = async () => {
      try {
        await navigator.clipboard.writeText(offerUrl);
        toast.success("Skopiowano link do oferty");
      } catch {
        showErrorToast("Nie uda\u0142o si\u0119 skopiowa\u0107 linku. Zaznacz go i skopiuj r\u0119cznie.");
      }
    };
    $[6] = offerUrl;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ClipboardDocumentIcon data-slot="icon" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <Button outline={true} type="button" className="w-full" onClick={t4}>{t5}Kopiuj link</Button>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t6) {
    t7 = <div role="status" className="flex w-full flex-col gap-3 rounded-lg border border-borderSuccess bg-backgroundSecondary p-4">{t1}{t2}{t3}{t6}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}